import { Country, FilterConfiguration, FilterState } from '@immosky/types';
import { FilterConfigurationFactory } from './filter-configuration-factory';

let previousCountry: Country | undefined = undefined;
let previousContractType = '';

export function updateFilterConfiguration(state: FilterState) {
  const config = FilterConfigurationFactory.create(state);
  const contractType = state.contractType.filter.value;

  if (
    previousCountry !== state.countries[0] ||
    previousContractType !== contractType
  ) {
    onCountryOrContractChange(state, config);

    previousCountry = state.countries[0];
    previousContractType = contractType;
  }

  state.category.sub.isDisplayed = config.displaySubcategory;
  state.livingSpace.isDisplayed = config.displayLivingSpace;
  state.propertySpace.isDisplayed = config.displayPropertySpace;
  state.usageSpace.isDisplayed = config.displayUsageSpace;
  state.roomCount.isDisplayed = config.displayRoomCount;
}

function onCountryOrContractChange(
  state: FilterState,
  config: FilterConfiguration
) {
  state.price.options = config.priceOptions;
  state.price.default.min = config.priceOptions[0];
  state.price.default.max = config.priceOptions[config.priceOptions.length - 1];
  state.price.filter = state.price.default;
  state.price.isActive = false;

  state.livingSpace.options = config.livingSpaceOptions;
  state.livingSpace.default.min = config.livingSpaceOptions[0];
  state.livingSpace.default.max =
    config.livingSpaceOptions[config.livingSpaceOptions.length - 1];
  state.livingSpace.filter = state.livingSpace.default;
  state.livingSpace.isActive = false;

  state.propertySpace.options = config.propertySpaceOptions;
  state.propertySpace.default.min = config.propertySpaceOptions[0];
  state.propertySpace.default.max =
    config.propertySpaceOptions[config.propertySpaceOptions.length - 1];
  state.propertySpace.filter = state.propertySpace.default;
  state.propertySpace.isActive = false;

  state.usageSpace.options = config.usageSpaceOptions;
  state.usageSpace.default.min = config.usageSpaceOptions[0];
  state.usageSpace.default.max =
    config.usageSpaceOptions[config.usageSpaceOptions.length - 1];
  state.usageSpace.filter = state.usageSpace.default;
  state.usageSpace.isActive = false;

  state.roomCount.options = config.roomCountOptions;
  state.roomCount.default.min = config.roomCountOptions[0];
  state.roomCount.default.max =
    config.roomCountOptions[config.roomCountOptions.length - 1];
  state.roomCount.filter = state.roomCount.default;
  state.roomCount.isActive = false;
}
